export var BillableStateType = /*#__PURE__*/ function(BillableStateType) {
    BillableStateType["Billable"] = "billable";
    BillableStateType["NonBillable"] = "nonBillable";
    return BillableStateType;
}({});
export var NonBillableReason = /*#__PURE__*/ function(NonBillableReason) {
    NonBillableReason["IssuingInvoice"] = "issuingInvoice";
    NonBillableReason["BilledMaxCharges"] = "billedMaxCharges";
    return NonBillableReason;
}({});
